//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux'

//maps
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import { db } from 'assets/firebase';

const { MarkerClusterer } = require("react-google-maps/lib/components/addons/MarkerClusterer");
const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={11}
      defaultCenter={props.userLocation}
      defaultOptions={{
        scrollwheel: false,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }]
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
          },
          { featureType: "poi.park", stylers: [{ visibility: "on" }] }
        ]
      }}
    >
    <MarkerClusterer
      averageCenter
      enableRetinaIcons
      gridSize={60}
    >
      {props.markers.map(marker => (
        
        <Marker
          key={marker.name}
          position={{ lat: marker.lat, lng: marker.lon }}
          title={marker.name}
        />
        
      ))}
    </MarkerClusterer>
    
    </GoogleMap>
  ))
);

function location(name, lat, lon) {
  this.name = name;
  this.lat = lat;
  this.lon = lon;
}

class Maps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: []
    };
  }

  componentDidMount() {

    var markers = [];

    if (this.props.user.authenticated) {
  
      db.getLocations(this.props.org.id).then(snapshot => {
        
        snapshot.forEach((doc) => {
          
          var x = doc.data();
          markers.push(new location(x.Name, x.Latitude, x.Longitude));
        });
        
        this.setState({markers:markers});
      });

    }
    
  }

  render() {
    
    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }
    
    return (
      <CustomSkinMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBXtw4_AbT-w4I05Jf2rtUVrxpOY5ukAAw"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100vh` }} />}
        mapElement={<div style={{ height: `95%` }} />}
        userLocation={{lat: 20.768151, lng: -156.250125}}
        markers={this.state.markers}
      />
    );
  }
}

const mapStateToProps = state => {
  return state;
}
Maps = connect(mapStateToProps)(Maps)
export default Maps;



// WEBPACK FOOTER //
// ./src/views/Maps/Maps.jsx